import { useEffect, useRef, useState } from 'react';

import { useIsWebAnimationsEnabled } from '@trello/animations';

/**
 * Pulses experiment exposure only when eligibility is already loaded as a
 * dialog session opens. A session that resolves eligibility later remains
 * immediate for its full lifetime and does not record a treatment exposure.
 */
export const useDialogMotion = (isOpen: boolean): boolean => {
  const [fireExposureEvent, setFireExposureEvent] = useState(false);
  const wasOpenRef = useRef(false);
  const isOpening = isOpen && !wasOpenRef.current;
  const { isEnabled, loading } = useIsWebAnimationsEnabled({
    fireExposureEvent,
  });

  useEffect(() => {
    wasOpenRef.current = isOpen;
    if (fireExposureEvent) {
      // TODO ENGHEALTH-2180: baselined when the rule was enabled
      setFireExposureEvent(false); // oxlint-disable-line react/set-state-in-effect
    } else if (isOpening && !loading) {
      setFireExposureEvent(true);
    }
  }, [fireExposureEvent, isOpen, isOpening, loading]);

  return isEnabled;
};
